/* CraftUs — interazioni front-end (M1)
   - mobile nav toggle
   - filtro tab "collezione del momento" (client-side per tag prodotto)
   - smooth scroll per anchor interni
*/
(function () {
  'use strict';

  /* --- Mobile nav ---------------------------------------------------------- */
  function initBurger() {
    document.querySelectorAll('[data-craft-burger]').forEach(function (btn) {
      var menuId = btn.getAttribute('data-craft-burger');
      var menu = document.getElementById(menuId);
      if (!menu) return;
      btn.addEventListener('click', function () {
        menu.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', menu.classList.contains('is-open'));
      });
    });
  }

  /* --- Featured collection tab filter ------------------------------------- */
  function initTabs() {
    document.querySelectorAll('[data-craft-tabs]').forEach(function (root) {
      var tabs = root.querySelectorAll('[data-craft-tab]');
      var cards = root.querySelectorAll('[data-craft-card]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var filter = tab.getAttribute('data-craft-tab');
          tabs.forEach(function (t) { t.classList.toggle('is-active', t === tab); });
          cards.forEach(function (card) {
            var tags = (card.getAttribute('data-craft-tags') || '').split(',');
            var show = filter === '*' || tags.indexOf(filter) !== -1;
            card.style.display = show ? '' : 'none';
          });
        });
      });
    });
  }

  /* --- Smooth scroll ------------------------------------------------------- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href*="#"]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        var hash = link.hash;
        if (!hash || hash.length < 2) return;
        // Solo se il link punta alla pagina corrente: altrimenti lascia
        // navigare (es. da /products/... verso /#sezione carica la home).
        if (link.pathname !== window.location.pathname) return;
        var target;
        try { target = document.querySelector(hash); } catch (err) { return; }
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        if (window.history && history.pushState) history.pushState(null, '', hash);
        var menu = link.closest('.craft-header__menu');
        if (menu) menu.classList.remove('is-open');
      });
    });
  }

  function init() {
    initBurger();
    initTabs();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
